import axios from "axios";
import { Login_Url } from "../../pages/Config";

const BASE_URL = `${Login_Url}api/users`;

const API_KEY = "a3f8c2d1e4b7a9f0c3d2e1b4a5f6c7d8e9f";

const authHeader = () => ({
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": API_KEY,
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

// GET ALL USERS
export const getUsers = () =>
  axios.get(BASE_URL, authHeader());

// REGISTER USER
export const registerUser = (data) =>
  axios.post(`${BASE_URL}/register`, data, authHeader());

// UPDATE USER
export const updateUser = (id, data) =>
  axios.put(`${BASE_URL}/${id}`, data, authHeader());